var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-skeleton"},[_c('div',{staticClass:"skeleton",class:[_vm.animated ? undefined : 'no-animate'],style:([_vm.style, _vm.innerStyle])})])}
var staticRenderFns = []

export { render, staticRenderFns }